import { Course, Interest } from "../../entities/entities";
import {interfaceInterestRepository} from "../../../infrastructure/repository/impl/interest_repository";
import { Order } from "../../entities/order";
import { ListResponse } from "../../entities/shop/product/listResponse";

interface InterestUseCases {
  list(): Promise<Interest[]>;
  relateInterestToUser(interests): Promise<void>;
  listUserInterest(): Promise<Interest[]>;
  getUserInterests(): Promise<Interest[]>;
  listTrainingsByInterest(order: Order, interestID: number): Promise<ListResponse<Course>>;
}

class _InterestUseCases implements InterestUseCases {
  async list(): Promise<Interest[]> {
    return await interfaceInterestRepository.list();
  }

  async listUserInterest(): Promise<Interest[]> {
    return await interfaceInterestRepository.listUserInterest();
  }

  async relateInterestToUser(interests): Promise<void> {
    return await interfaceInterestRepository.relateInterestToUser(interests);
  }

  async getUserInterests(): Promise<Interest[]> {
    return await interfaceInterestRepository.getUserInterests();
  }

  async listTrainingsByInterest(order: Order, interestID: number): Promise<ListResponse<Course>> {
    return await interfaceInterestRepository.listTrainingsByInterest(order, interestID);
  }
}

export const InterfaceInterestUseCases: InterestUseCases = new _InterestUseCases();
